import { create } from 'zustand';

const LS_KEY = 'mdv-blockmodel-grade-filters';
const LS_MIN_CUTOFF_MIGRATION = 'mdv-blockmodel-min-03';

export const DEFAULT_BLOCK_MODEL_MIN = 0.3;
export const DEFAULT_BLOCK_MODEL_MAX = null;

export function resolvedGradeMin(filter) {
  if (Number.isFinite(filter?.min)) return filter.min;
  return DEFAULT_BLOCK_MODEL_MIN;
}

function emptyFilter() {
  return { min: null, max: null, colorBy: null };
}

function saveFilter(filter) {
  try {
    localStorage.setItem(
      LS_KEY,
      JSON.stringify({
        min: Number.isFinite(filter.min) ? filter.min : null,
        max: Number.isFinite(filter.max) ? filter.max : null,
        colorBy: filter.colorBy || null,
      })
    );
  } catch {
    // quota or private mode
  }
}

function sanitizeFilter(row) {
  const minRaw = row?.min == null || row.min === '' ? null : Number(row.min);
  const maxRaw = row?.max == null || row.max === '' ? null : Number(row.max);
  return {
    min: Number.isFinite(minRaw) ? minRaw : null,
    max: Number.isFinite(maxRaw) ? maxRaw : null,
    colorBy: typeof row?.colorBy === 'string' && row.colorBy.trim() ? row.colorBy.trim() : null,
  };
}

function loadFilter() {
  try {
    localStorage.setItem(LS_MIN_CUTOFF_MIGRATION, '1');
  } catch {
    /* ignore */
  }
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return emptyFilter();
    const data = JSON.parse(raw);
    if (!data || typeof data !== 'object' || Array.isArray(data)) return emptyFilter();
    const nested = Object.values(data).some((v) => v && typeof v === 'object' && !Array.isArray(v));
    if (nested) return emptyFilter();
    return sanitizeFilter(data);
  } catch {
    return emptyFilter();
  }
}

export function isBlockModelLayer(model) {
  return String(model?.type || '').toLowerCase() === 'blockmodel';
}

export const useBlockModelFilterStore = create((set, get) => ({
  filter: loadFilter(),
  legendOpen: false,
  layerMeta: {},
  setLayerMeta: (layerKey, meta) => {
    if (!layerKey) return;
    set((state) => ({
      layerMeta: { ...state.layerMeta, [layerKey]: { ...(state.layerMeta[layerKey] || {}), ...meta } },
    }));
  },
  setFilter: (patch) => {
    const next = sanitizeFilter({ ...get().filter, ...(patch || {}) });
    saveFilter(next);
    set({ filter: next });
  },
  resetFilter: () => {
    const next = emptyFilter();
    saveFilter(next);
    set({ filter: next });
  },
  setLegendOpen: (open) => set({ legendOpen: !!open }),
  toggleLegend: () => set((state) => ({ legendOpen: !state.legendOpen })),
}));
